import React, { useState } from 'react';
import TokenImageUpload from './TokenImageUpload';

const UpdateTokenImage = ({ token, onUpdate, onClose }) => {
  const [tokenImage, setTokenImage] = useState(token.token_image || token.image || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpdateImage = async () => {
    setLoading(true);
    setError('');

    try {
      const authToken = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/authorized-tokens/${token.token_id}/image`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
          },
          body: JSON.stringify({ tokenImage })
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to update image');
      }

      const data = await response.json();
      
      // Call the onUpdate callback to refresh the parent component
      if (onUpdate) {
        onUpdate({ ...token, token_image: tokenImage });
      }
      
      // Close the modal/form
      if (onClose) {
        onClose();
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <h3 className="text-xl font-semibold mb-4">
        Update Image for {token.token_name || token.name}
      </h3>
      
      <div className="mb-4">
        <TokenImageUpload
          currentImage={tokenImage}
          onImageChange={setTokenImage}
        />
      </div>
      
      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
          {error}
        </div>
      )}
      
      <div className="flex justify-end space-x-2">
        <button
          onClick={onClose}
          className="px-4 py-2 border rounded hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          onClick={handleUpdateImage}
          disabled={loading || !tokenImage}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {loading ? 'Updating...' : 'Update Image'}
        </button>
      </div>
    </div>
  );
};

export default UpdateTokenImage;